/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';

import {
  useFetchableResource,
  useGetResource,
  useFetch,
  FetchOptions,
  FetchSkippableOptions,
  FetchNonThrowingOverloadOptions,
} from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiGetWorkspaceMembersResponse,
  getCoinbaseEngUsersAccountManagementApiApiGetWorkspaceMembersResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiGetWorkspaceMembersResponse';

export type WorkspaceMembersArgs = {
  /**
   * No description provided
   */
  organizationId?: string;

  filters?: {
    /**
     * No description provided
     */
    legalEntityIds?: string[];
  };
};

export type WorkspaceMembersResult =
  CoinbaseEngUsersAccountManagementApiApiGetWorkspaceMembersResponse;

const validateWorkspaceMembersResult = (value: unknown) => {
  const errors = getCoinbaseEngUsersAccountManagementApiApiGetWorkspaceMembersResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: WorkspaceMembersResult data does not match contract.`,
      errors,
    );
  }
};

export const getWorkspaceMembersUrl = (
  params: WorkspaceMembersArgs,
  {
    additionalParams,
    baseUrl,
  }: {
    additionalParams?: Record<string, unknown>;
    baseUrl?: string;
  } = {},
) => {
  const searchParams = new URLSearchParams();
  if (params.organizationId !== null && params.organizationId !== undefined) {
    const val = params.organizationId;
    searchParams.append('organization_id', `${val}`);
  }

  if (params.filters?.legalEntityIds !== null && params.filters?.legalEntityIds !== undefined) {
    const val = params.filters?.legalEntityIds;
    Array.isArray(val) && val.forEach((_) => searchParams.append('filters.legal_entity_ids', _));
  }

  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== null && value !== undefined && !searchParams.has(key)) {
        searchParams.append(key, `${value}`);
      }
    }
  }
  const url = `${baseUrl || getBaseUrl()}/organization/v1/workspace/members${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Fetch WorkspaceMembers
 * @Url /organization/v1/workspace/members
 * @Auth Required
 */

export function useGetWorkspaceMembers(
  params: WorkspaceMembersArgs,
  options: FetchSkippableOptions | FetchNonThrowingOverloadOptions,
): WorkspaceMembersResult | undefined;

export function useGetWorkspaceMembers(
  params: WorkspaceMembersArgs,
  options?: FetchOptions,
): WorkspaceMembersResult;

export function useGetWorkspaceMembers(
  params: WorkspaceMembersArgs,
  options?: FetchOptions | FetchSkippableOptions | FetchNonThrowingOverloadOptions,
) {
  const url = getWorkspaceMembersUrl(params, options);
  const data = useFetch<WorkspaceMembersResult>({ url, ...options });

  if (process.env.NODE_ENV !== 'production') {
    validateWorkspaceMembersResult(data);
  }

  return data;
}

/**
 * Access WorkspaceMembers fetch callback
 */
export const useGetWorkspaceMembersCallback = () => {
  const getResource = useGetResource();

  const fetch = useCallback(
    async (params: WorkspaceMembersArgs, additionalHeaders?: Record<string, string>) => {
      const url = getWorkspaceMembersUrl(params);
      const resource = getResource<WorkspaceMembersResult>(url, undefined, additionalHeaders);

      await resource.fetch();
      const data =
        resource.data == null
          ? new Error('FetchableResource completed but no data or error was set')
          : resource.data;

      if (process.env.NODE_ENV !== 'production') {
        validateWorkspaceMembersResult(data);
      }

      return data;
    },
    [getResource],
  );

  return fetch;
};

/**
 * Refresh WorkspaceMembers without throwing to suspense
 * @Url /organization/v1/workspace/members
 * @Auth Required
 */
export const useRefreshWorkspaceMembers = (
  params: WorkspaceMembersArgs,
  additionalParams: {
    disableCamelize?: boolean;
    additionalHeaders?: Record<string, string>;
  } = {},
) => {
  const { disableCamelize, additionalHeaders } = additionalParams;
  const url = getWorkspaceMembersUrl(params);

  const { fetch } = useFetchableResource<WorkspaceMembersResult>(
    url,
    disableCamelize,
    additionalHeaders,
  );

  return fetch;
};

/**
 * Remove WorkspaceMembers from cache without refetching. Subscribed components may refresh and throw to suspense.
 * @Url /organization/v1/workspace/members
 */
export const useClearWorkspaceMembers = (params: WorkspaceMembersArgs) => {
  const url = getWorkspaceMembersUrl(params);

  const { clear } = useFetchableResource<WorkspaceMembersResult>(url);

  return clear;
};

export const useWithOptimisticWorkspaceMembersUpdates = (params: WorkspaceMembersArgs) => {
  const url = getWorkspaceMembersUrl(params);

  const { optimisticUpdate } = useFetchableResource<WorkspaceMembersResult>(url);

  return optimisticUpdate;
};
